import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiAlertTriangle } from 'react-icons/fi';
import SACSection from './SACSection';
import SpaceRoomTypes from './SpaceRoomTypes';
import DesignInformation from './DesignInformation';
import MaterialSpecifications from './MaterialSpecifications';
import FeaturedBrands from './FeaturedBrands';

const OwnerProjectRequirements = ({ data, updateData, onNext, onBack, partOneCompleted }) => {
  const validateAndContinue = () => {
    if (!partOneCompleted) {
      alert('Please complete Part I - Project Information first before proceeding.');
      onBack();
      return;
    }
    
    // This would normally validate the OPR data
    // For now we just continue to the next step
    onNext();
  };

  return (
    <section className="card grid gap-4">
      <h2 className="text-base font-semibold">Part II — Owner Project Requirements (OPR)</h2>
      
      {!partOneCompleted && (
        <div className="p-3 bg-amber-50 border border-amber-200 rounded-lg flex items-center gap-2">
          <SafeIcon icon={FiAlertTriangle} className="text-amber-500" size={20} />
          <div>
            <div className="font-semibold text-amber-800">Project Information Incomplete</div>
            <div className="text-sm text-amber-700">
              Please complete all required fields in Part I before proceeding with OPR details.
              You can still enter information here, but it will not be processed until Part I is complete.
            </div>
          </div>
        </div>
      )}
      
      <div className={partOneCompleted ? '' : 'opacity-75'}>
        <SACSection data={data} updateData={updateData} />
        <SpaceRoomTypes data={data} updateData={updateData} />
        <DesignInformation data={data} updateData={updateData} />
        <FeaturedBrands />
        <MaterialSpecifications data={data} updateData={updateData} />
      </div>
      
      <div className="flex justify-between gap-2 mt-4">
        <button className="btn" onClick={onBack}>← Back to Part I</button>
        <button
          className={`btn btn-primary ${!partOneCompleted ? 'opacity-75' : ''}`}
          onClick={validateAndContinue}
        >
          Generate Sync Results →
        </button>
      </div>
    </section>
  );
};

export default OwnerProjectRequirements;